"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableContextBuilder = void 0;
var _tableContextHelpers = require("./tableContextHelpers");
var _tableHelpers = require("../../../helpers/tableHelpers");
var _tableState = require("./tableState");
var _quoteHelpers = require("../../../helpers/quoteHelpers");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TableContextBuilder = exports.TableContextBuilder = function TableContextBuilder(_ref) {
  var _currentTableState$mo;
  var _ref$currentTableStat = _ref.currentTableState,
    currentTableState = _ref$currentTableStat === void 0 ? null : _ref$currentTableStat,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'pinscom' : _ref$brand,
    brandTextElements = _ref.brandTextElements,
    dataIsUpdating = _ref.dataIsUpdating,
    _ref$tableLayoutConfi = _ref.tableLayoutConfiguration,
    tableLayoutConfiguration = _ref$tableLayoutConfi === void 0 ? null : _ref$tableLayoutConfi,
    _ref$hideProductVaria = _ref.hideProductVariants,
    hideProductVariants = _ref$hideProductVaria === void 0 ? true : _ref$hideProductVaria,
    productDefinitions = _ref.productDefinitions,
    productGroupFilter = _ref.productGroupFilter,
    productQuotes = _ref.productQuotes,
    quotesContext = _ref.quotesContext,
    _ref$showProductGroup = _ref.showProductGroupControls,
    showProductGroupControls = _ref$showProductGroup === void 0 ? false : _ref$showProductGroup,
    _ref$showBaseWithoutD = _ref.showBaseWithoutDiscount,
    showBaseWithoutDiscount = _ref$showBaseWithoutD === void 0 ? true : _ref$showBaseWithoutD,
    _ref$speciesFilter = _ref.speciesFilter,
    speciesFilter = _ref$speciesFilter === void 0 ? 'all' : _ref$speciesFilter,
    _ref$staffMode = _ref.staffMode,
    staffMode = _ref$staffMode === void 0 ? false : _ref$staffMode,
    _ref$staffExpertMode = _ref.staffExpertMode,
    staffExpertMode = _ref$staffExpertMode === void 0 ? false : _ref$staffExpertMode,
    _ref$mobileMode = _ref.mobileMode,
    mobileMode = _ref$mobileMode === void 0 ? false : _ref$mobileMode,
    staffModeContext = _ref.staffModeContext,
    _ref$petSureStaffMode = _ref.petSureStaffMode,
    petSureStaffMode = _ref$petSureStaffMode === void 0 ? false : _ref$petSureStaffMode,
    _ref$selectedProduct = _ref.selectedProduct,
    selectedProduct = _ref$selectedProduct === void 0 ? currentTableState === null || currentTableState === void 0 ? void 0 : currentTableState.selectedProduct : _ref$selectedProduct,
    _ref$selectedQuote = _ref.selectedQuote,
    selectedQuote = _ref$selectedQuote === void 0 ? null : _ref$selectedQuote,
    _ref$petIndex = _ref.petIndex,
    petIndex = _ref$petIndex === void 0 ? 0 : _ref$petIndex,
    _ref$ageFilter = _ref.ageFilter,
    ageFilter = _ref$ageFilter === void 0 ? null : _ref$ageFilter;
  var productsAreMerged = hideProductVariants && !petSureStaffMode;
  var newTableContext = _objectSpread(_objectSpread({}, (0, _tableContextHelpers.InitialiseTableContext)({
    productDefinitions: productDefinitions,
    brand: brand,
    tableLayoutConfiguration: tableLayoutConfiguration,
    speciesFilter: speciesFilter,
    staffMode: staffMode,
    staffExpertMode: staffExpertMode,
    petSureStaffMode: petSureStaffMode,
    productsAreMerged: productsAreMerged,
    brandTextElements: brandTextElements,
    quotesContext: quotesContext,
    ageFilter: ageFilter
  })), {}, {
    brand: brand,
    showProductGroupControls: showProductGroupControls,
    showBaseWithoutDiscount: showBaseWithoutDiscount,
    productGroupFilter: productGroupFilter,
    productDefinitions: productDefinitions,
    petIndex: petIndex
  });
  var visiblePlans = (0, _tableHelpers.GetVisiblePlans)({
    tableContext: newTableContext
  });
  var selectedOptions = {
    merged: _objectSpread(_objectSpread(_objectSpread({}, newTableContext.initialPlanOptionsState.merged), currentTableState && currentTableState.selectedOptions && currentTableState.selectedOptions.merged || {}), selectedQuote && selectedProduct && _defineProperty({}, selectedQuote.productName, {
      dental: selectedProduct.dental ? 'yes' : 'no',
      excess: selectedQuote.excess.toString(),
      levelOfCover: selectedQuote.levelOfCover,
      routineCare: selectedProduct.routineCare ? 'yes' : 'no',
      annualLimit: selectedProduct.limits.annualLimit.amount
    })),
    allPlans: _objectSpread(_objectSpread({}, newTableContext.initialPlanOptionsState.allPlans), currentTableState && currentTableState.selectedOptions && currentTableState.selectedOptions.allPlans || {})
  };
  var mobileModeVisibility = _objectSpread(_objectSpread({}, currentTableState === null || currentTableState === void 0 || (_currentTableState$mo = currentTableState.mobileSettings) === null || _currentTableState$mo === void 0 ? void 0 : _currentTableState$mo.visibilityMap), newTableState === null || newTableState === void 0 ? void 0 : newTableState.mobileSettings.visibilityMap);
  var groupDisplayStates = currentTableState && currentTableState.groupDisplayStates && Object.keys(currentTableState.groupDisplayStates).length > 0 ? currentTableState.groupDisplayStates : newTableContext.groupDisplayStates;
  var newTableState = _objectSpread(_objectSpread(_objectSpread({}, _tableState.InitialTableState), currentTableState), {}, {
    dataIsUpdating: dataIsUpdating,
    selectedOptions: selectedOptions,
    selectedProduct: selectedProduct,
    groupDisplayStates: groupDisplayStates,
    visiblePlans: visiblePlans,
    staffMode: petSureStaffMode ? true : staffMode,
    staffExpertMode: staffExpertMode,
    staffModeContext: staffModeContext,
    petSureStaffMode: petSureStaffMode,
    productQuotes: productQuotes,
    quotesContext: quotesContext,
    productsAreMerged: productsAreMerged,
    mobileSettings: {
      mobileMode: mobileMode,
      visibilityMap: mobileModeVisibility
    },
    filteredQuotes: (0, _quoteHelpers.FilterQuotesByVariations)({
      productQuotes: productQuotes,
      productGroups: newTableContext.ProductGroupsKeyedByPlanNumber,
      selectedOptions: selectedOptions,
      AllPlans: newTableContext.AllPlans,
      AddOnsMap: newTableContext.AddOnsMap,
      productsAreMerged: productsAreMerged
    })
  });
  return {
    newTableState: newTableState,
    newTableContext: newTableContext
  };
};